import { createStandaloneToast } from "@chakra-ui/toast";
import { useEffect, useState } from "react";
import { countVideoPerDay, getJsonObj, getTreeMapData, getWordCloudData } from "../utils";
import { getBarChartRaceData } from "../utils";

export default function useChartData(chartType, jsonObj, setJsonObj) {
  const [result, setResult] = useState();
  const [loading, setLoading] = useState(true);
  // const [isDemo, setIsDemo] = useState(false);

  const toast = createStandaloneToast();

  useEffect(() => {
    async function fetchChartData() {
      try {
        setLoading(true);

        // if App-State holds no jsonObj, try to find it in the indexedDb
        // i.e when page is refreshed
        if (!jsonObj) {
          // eslint-disable-next-line
          jsonObj = await getJsonObj();
          // we set the app state, so we dont need to execute the db-query again
          // (as long as the site is not refreshed)
          setJsonObj(jsonObj);
          // used by Demo-InfoBanner
          jsonObj
            ? sessionStorage.setItem("isDemo", false)
            : sessionStorage.setItem("isDemo", true);
        }

        switch (chartType) {
          case "barchartrace":
            const barchartRaceData = getBarChartRaceData(jsonObj);

            setResult(barchartRaceData);
            break;

          case "wordcloud":
            const wordCloudData = getWordCloudData(jsonObj);
            setResult(wordCloudData);
            break;

          case "treemap":
            const treeMapData = getTreeMapData(jsonObj);
            setResult(treeMapData);
            break;

          case "columnchart":
            const countsPerDay = countVideoPerDay(jsonObj);
            setResult(countsPerDay);
            break;

          default:
            setResult(jsonObj);
            break;
        }
        setLoading(false);
      } catch (error) {
        toast({
          title: "An error occurred.",
          description: "Something went wrong, while processing your file",
          status: "error",
          duration: 7000,
          isClosable: true,
        });
        console.error(error);
        setLoading(false);
      }
    }
    fetchChartData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartType]);

  return [result, loading];
}
